module.exports = __webpack_public_path__ + "/content/shared/img/audi/Audi_LandingImage_5.jpg";